<template>
  <div>
    <div class="row">
      <div class="col-md-12">
        <div class="m-portlet m-portlet--tab">
          <div class="m-portlet__body">
            <div>
              <span class="loading-request" v-show="loading"></span>
              <div
                class="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pb-2 mb-4 border-bottom"
              >
                <h1 class="h2">POCs</h1>
                <div class="btn-toolbar mb-2 mb-md-0">
                  <div class="btn-group btn-group-sm" role="group" aria-label="Menu das pocs">
                    <span
                      class="btn btn-outline-brand"
                      @click="openSavePoc('add')"
                      v-b-tooltip.hover
                      title="Nova POC!"
                    >
                      <i class="fas fa-plus-square"></i>&nbsp; Nova POC
                    </span>
                  </div>
                </div>
              </div>
              <PaginatorTop
                :from="data.from"
                :amount="amount"
                :to="data.to"
                :total="data.total"
                @setAmountPerPage="setAmountPerPage"
              >
              </PaginatorTop>
            </div>
            <ListTable
              :columns="table"
              :sortType="sortType"
              :sortReverse="sortReverse"
              :filters="tableFilters"
              :data="data"
              :actions="actions"
              @callData="callDataUpdate"
              @clearFilters="clearFilters"
              @editItem="openSavePoc"
              @deleteItem="confirmDelete"
              @sortCall="sortCall"
            ></ListTable>
            <PaginatorBottom
              :from="data.from"
              :amount="amount"
              :to="data.to"
              :total="data.total"
              :current_page="data.current_page"
              :last_page="data.last_page"
              @setPage="setPage"
            >
            </PaginatorBottom>
            <div class="pt-4"></div>
          </div>
        </div>
      </div>
      <transition name="slideleft" mode="out-in">
        <PocModal v-if="showPocSave" @updateList="callData" />
      </transition>
      <transition name="fade" mode="out-in">
        <div class="m-quick-sidebar-overlay" v-if="showPocSave" @click="closePocSave()"></div>
      </transition>
    </div>
  </div>
</template>

<script>
import { returnMessageMixin } from '@/mixins/returnMessageMixin.js';
import PaginatorTop from '@/components/template/paginator/Top';
import PaginatorBottom from '@/components/template/paginator/Bottom';
import ListTable from '@/components/template/tables/ListEntitySimple';
import PocModal from '@/components/pocs/PocModal';

import { baseApiUrl } from '@/global';
import axios from 'axios';

export default {
  mixins: [returnMessageMixin],
  name: 'Customers',
  components: { PaginatorTop, PaginatorBottom, ListTable, PocModal },
  data() {
    const table = this.setTableInformation();
    const tableFilters = this.setTableFilters();
    const actions = this.setTableActions();
    return {
      table,
      tableFilters,
      actions,
      filters: {},
      amount: localStorage.pocDataAmount ? localStorage.pocDataAmount : 100,
      sortType: localStorage.pocSortType ? localStorage.pocSortType : 'id',
      sortReverse: localStorage.pocSortReverse ? localStorage.pocSortReverse : false,
      page: localStorage.pocDataPage ? localStorage.pocDataPage : 1,
      data: [],
    };
  },
  computed: {
    loading() {
      return !this.data.current_page;
    },
    showPocSave() {
      return this.$store.state.showPocSave;
    },
  },
  methods: {
    callData() {
      this.data.current_page = null;
      this.getDatas();
    },
    getDatas() {
      const url = `${baseApiUrl}/v1/customer/pocs/search${this.convertFilters()}`;
      axios(url).then((res) => {
        this.data = res.data;
        if (res.data.current_page > res.data.last_page) {
          this.page = 1;
        }
      });
    },
    convertFilters() {
      let filters = `?page=${this.page ? this.page : 1}&amount=${this.amount}&sortType=${
        this.sortType
      }&sortOrder=${this.sortReverse ? 'DESC' : 'ASC'}`;

      this.tableFilters.forEach((applyFilter) => {
        filters = `${filters}&${applyFilter.key}=${
          this.filters[applyFilter.key] ? this.filters[applyFilter.key] : ''
        }`;
      });
      return filters;
    },
    sortCall(sortType) {
      this.sortReverse = this.sortType === sortType ? !this.sortReverse : false;
      this.sortType = sortType;
    },
    setAmountPerPage(newAmount) {
      this.amount = newAmount;
    },
    setPage(newPage) {
      this.page = newPage;
    },
    setTableInformation() {
      return [
        {
          key: 'id',
          label: 'ID POC',
          type: 'number',
          width: 80,
          sort: true,
        },
        {
          key: 'customer.customerable.name',
          type: 'text',
          label: 'Cliente',
          width: 220,
          sort: false,
        },
        {
          key: 'customer.documents.value',
          type: 'document',
          label: 'Documento',
          width: 150,
          sort: false,
        },
        {
          key: 'contract.id',
          type: 'number',
          label: 'Contrato',
          width: 15,
          sort: false,
        },
        {
          key: 'start',
          type: 'date',
          label: 'Inicio',
          width: 10,
          sort: true,
        },
        {
          key: 'finish',
          type: 'date',
          label: 'Fim',
          width: 10,
          sort: true,
        },
      ];
    },
    setTableFilters() {
      return [
        {
          key: 'id',
          type: 'number',
        },
        {
          key: 'customer_name',
          type: 'text',
        },
        {
          key: 'cnpj',
          type: 'text',
        },
        {
          key: 'contract_id',
          type: 'number',
        },
        {
          key: 'start',
          type: 'date',
          tooltip: 'A partir de:',
        },
        {
          key: 'finish',
          type: 'date',
          tooltip: 'A partir de:',
        },
        {
          key: 'clearFilter',
        },
      ];
    },
    setTableActions() {
      return [
        {
          key: 'edit',
          icon: 'fa-edit',
          title: 'Editar',
        },
        {
          key: 'delete',
          icon: 'fa-trash-alt',
          title: 'Deletar',
        },
      ];
    },
    openSavePoc(id) {
      this.$store.state.showPocSave = id;
    },
    closePocSave() {
      this.$store.state.showPocSave = null;
      this.callData();
    },
    callDataUpdate(filters) {
      this.filters = filters;
      this.callData();
    },
    clearFilters() {
      this.filters = {};
      this.filters.sortType = 'id';
      this.filters.sortReverse = false;
      this.callData();
    },
    confirmDelete(id) {
      this.dialog = '';
      this.$bvModal
        .msgBoxConfirm('Tem certeza que deseja excluir a POC selecionada?', {
          size: 'md',
          contentClass: 'p-3',
          bodyClass: 'modal-body-fix',
          buttonSize: 'md',
          okVariant: 'danger',
          okTitle: 'Confirmar exclusão',
          cancelTitle: 'Cancelar',
          cancelVariant: 'metal',
          footerClass: 'p-4',
          hideHeaderClose: true,
          centered: true,
        })
        .then((value) => {
          if (value == true) {
            this.deleteItem(id);
          }
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
    deleteItem(id) {
      const url = `${baseApiUrl}/v1/customer/pocs/delete/${id}`;
      axios
        .delete(url)
        .then((res) => {
          this.logMessage(res);
          this.getDatas();
        })
        .catch((error) => {
          this.logMessageFailed(error.response);
        });
    },
  },
  watch: {
    amount() {
      if (this.page === 1) {
        this.callData();
      } else {
        this.page = 1;
      }
    },
    page() {
      this.callData();
    },
    sortType() {
      this.callData();
    },
    sortReverse() {
      this.callData();
    },
  },
  mounted() {
    this.getDatas();
    window.scroll(0, 0);
  },
};
</script>
